<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25 footer-text">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <span class="text-bold">Talleres Mata</span>
    </span>
    <span class="float-md-right d-block d-md-inline-block mt-25 footer-text">
      Version 1.0.0
    </span>
  </p>
</template>

<script>
export default {};
</script>
